import React from 'react';
import { Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../CustomCodes.redux';

const SelectType = () => {
    const dispatch = useDispatch(),
        value = useSelector((state) => state.customCodes.type),
        step = useSelector((state) => state.customCodes.step);

    const handleChange = (e) => {
        dispatch(actions.setState({ type: e.target.value }));
    };

    const handleNext = () => {
        dispatch(actions.setState({ step: step + 1 }));
    };

    return (
        <div>
            <FormControl sx={{ width: '240px' }}>
                <InputLabel id="custom-code-select-type-label">Type</InputLabel>
                <Select
                    labelId="custom-code-select-type-label"
                    id="custom-code-select-type"
                    value={value}
                    label="Type"
                    onChange={handleChange}
                    sx={{ width: '100%' }}
                    fullWidth
                >
                    <MenuItem value="single">Basic</MenuItem>
                    <MenuItem value="multiselect">Multiple Choice</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default SelectType;
